import * as React from 'react';
import Helmet from 'react-helmet';

import { Footer, Header } from 'common/components';
import { WhitelabelContainer } from '../';
import Routes from '../Routes';

class VivaCruises extends WhitelabelContainer {
  getContent = () => {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        <Header logo="https://www.viva-cruises.com/_logo/viva-cruises-logo.png" />
        <Routes />
        <Footer />
      </>
    );
  };

  componentDidMount() {
    console.log('Mandator: VIVA Cruises');
  }
}

export default VivaCruises;
